import app from '@/app';
import templateUrl from './reinforcementCalculation-detail.html';

/* @ngInject */
function Controller($controller, ReinforcementCalculation, ConstantSet, GrowthRate, Principal, $http, AlertService, $state) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

	$ctrl.allRateType = ["FIXED", "VARIABLE"];

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: ReinforcementCalculation,
		type: 'reinforcementCalculation'
	});

	// Override save to use 'entity.update.message' (async Plan module)
	$ctrl.save = () => {
		if (!$ctrl.readonly) {
			$ctrl.isSaving = true;
			const onSuccess = () => {
				AlertService.success('entity.update.message', {
					type: $ctrl.type,
					name: $ctrl.entity.name
				});
				$ctrl.isSaving = false;
				$state.go('^', {}, { reload: true });
			};
			const onError = error => {
				$ctrl.isSaving = false;
			};
			if ($ctrl.entity.id) {
				ReinforcementCalculation.update($ctrl.entity, onSuccess, onError);
			} else {
				ReinforcementCalculation.create($ctrl.entity, onSuccess, onError);
			}
		}
	};

	$http.get('api/projects', { params: { onlyUsed: true } }).then(function(response) {
		$ctrl.allProjects = response.data.content;
	});

	$ctrl.reinforcementCalculationSave = () => {
		$ctrl.entity.plantype = 'REINFORCEMENT';
		$ctrl.entity.requestedYears = 1;
		$ctrl.save();
	};

	$ctrl.onRoadSelected = road => {
		$ctrl.entity.road = road;
		$ctrl.entity.headMilestone = road.headMilestone;
		$ctrl.entity.tailMilestone = road.tailMilestone;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaigns = null;
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaigns = null;
	};

  $ctrl.queryGrowthRates = query => {
		$ctrl.loading = true;
		return GrowthRate.query({ query: query, size: 10, sort: 'name,asc' }, data => {
			$ctrl.allGrowthRates = data;
			$ctrl.loading = false;
		}).$promise;
	};

	$ctrl.queryConstantSets = query => {
		$ctrl.loading = true;
		return ConstantSet.query({ query: query, size: 10, sort: 'name,asc' }, data => {
			$ctrl.allConstantSets = data;
			$ctrl.loading = false;
		}).$promise;
	};

	$ctrl.byOrganization = value =>
		$ctrl.entity.organization && value.organization.id == $ctrl.entity.organization.id;

	$ctrl.byOwner = value =>
		$ctrl.entity.organization && value.owner.id == $ctrl.entity.organization.id;
}

app.component('reinforcementCalculationDetail', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^reinforcementCalculationSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<'
	}
});
